/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormGroup, Checkbox } from '@carbon/react';
import { useTranslation } from '../../../../Utilities/i18n/i18n.js';
import { emptyArray, noopFn } from '../../../../Utilities/propHelpers/defaultProps.js';
import TableSettingsOption from './TableSettingsOption.js';

var TableSettingsColumns = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var headerOptions = _ref.headerOptions,
    _ref$initialCols = _ref.initialCols,
    initialCols = _ref$initialCols === void 0 ? emptyArray : _ref$initialCols,
    _ref$minCols = _ref.minCols,
    minCols = _ref$minCols === void 0 ? 1 : _ref$minCols,
    _ref$onChange = _ref.onChange,
    onChangeProp = _ref$onChange === void 0 ? noopFn : _ref$onChange,
    handleMenuItemFocus = _ref.handleMenuItemFocus;
  var _useState = useState(initialCols),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _onChange = function onChange(checked, id) {
    var selectedSet = new Set(selected);
    if (checked) {
      selectedSet.add(id);
    } else {
      selectedSet["delete"](id);
    }
    setSelected(_toConsumableArray(selectedSet));
    onChangeProp(_toConsumableArray(selectedSet));
  };
  return /*#__PURE__*/React.createElement(TableSettingsOption, {
    ref: ref
  }, /*#__PURE__*/React.createElement(FormGroup, {
    legendText: t('Edit columns')
  }, headerOptions.filter(function (header) {
    return header.header;
  }) // exclude columns without label
  .map(function (header) {
    var checked = selected.includes(header.key);
    var disabled = selected.length === minCols && checked; // disable if this is the only selected option
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: header.key,
      id: header.key,
      labelText: header.header,
      defaultChecked: checked,
      disabled: disabled,
      onChange: function onChange(event, _ref2) {
        var newChecked = _ref2.checked,
          id = _ref2.id;
        _onChange(newChecked, id);
      },
      onKeyDown: handleMenuItemFocus,
      "data-table-settings-item-focusable": true
    });
  })));
});
TableSettingsColumns.propTypes = {
  /**
   * Provide an array of header objects
   */
  headerOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  /**
   * Provide an optional array of initially selected columns
   */
  initialCols: PropTypes.arrayOf(PropTypes.string),
  /**
   * Provide an optional number of minimum selected columns
   */
  minCols: PropTypes.number,
  /**
   * Provide an optional hook that is called each time the selection is updated
   */
  onChange: PropTypes.func,
  /**
   * Provide an optional hook that is called each time a key is pressed
   */
  handleMenuItemFocus: PropTypes.func
};
var TableSettingsColumns$1 = TableSettingsColumns;

export { TableSettingsColumns$1 as default };
